import { useState } from "react";
import { Grid, Typography, Box, Button, Divider } from "@mui/material";
import { useTranslator } from "../../context/TranslatorContext";

const LanguageListSnippet = ({ languages = [] }) => {
  const [showAll, setShowAll] = useState(false);
  const {messages} = useTranslator();
  if (!languages || languages.length === 0) return null;

  const displayedLanguages = showAll ? languages : languages.slice(0, 3);
  const hasMore = languages.length > 3;

  return (
    <Grid item sx={{mt: 1}}>
      <Box display="flex" flexDirection="row" alignItems="center" flexWrap="wrap">
        <Typography variant="body1" color="text.secondary" sx={{ mr: 1 }}>
          {messages.snippetLanguagesLabel}:
        </Typography>
        {displayedLanguages.map((item, index) => (
          <Box
            key={index}
            component="span"
            sx={{ display: 'inline-flex', alignItems: 'center', mr: 1 }}
          >
            <Typography variant="body1" color="text.secondary">
              {item}
            </Typography>
            {index < displayedLanguages.length - 1 && (
              <Box
                sx={{
                  width: 4,
                  height: 4,
                  borderRadius: '50%',
                  backgroundColor: '#0F2651',
                  ml: 1,
                }}
              />
            )}
          </Box>
        ))}
        {hasMore && (
          <Button
            size="small"
            onClick={() => setShowAll(!showAll)}
            sx={{ minWidth: "auto", padding: 0, textTransform: "none" }}
          >
            <Typography variant="caption" color="primary">
              {showAll ? "Show less" : "..."}
            </Typography>
          </Button>
        )}
      </Box>
    </Grid>
  );
};

export default LanguageListSnippet;
